module.exports = __webpack_public_path__ + "static/media/QC.228522df.svg";